import { render, staticRenderFns } from "./VideoBlock.vue?vue&type=template&id=50841f0d"
import script from "./VideoBlock.vue?vue&type=script&lang=ts"
export * from "./VideoBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports